import { useQuery } from 'react-query'
import { ModalForm } from './ModalForm'
import { QUERIES } from '../../../../../_metronic/helpers'
import { useListViewBDT } from '../core/ListViewProviderBDT'
import { getDeviceDisplayActive } from '../core/_requests'
import { useAuth } from '../../../../modules/auth/core/Auth'
import { Loading } from '../../../../../_metronic/layout/components/loading/Loading'
import Swal from 'sweetalert2'
import { useQueryResponse } from '../core/QueryResponseProviderBDT'

const ModalFormWrapper = () => {
  const { auth } = useAuth()
  const { itemIdForSettingLed, setItemIdForSettingLed } = useListViewBDT()
  const { refetch } = useQueryResponse()
  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForSettingLed('')
  }
  const {
    isLoading,
    data: device,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-${itemIdForSettingLed}`,
    () => {
      return getDeviceDisplayActive(auth?.configs, itemIdForSettingLed || '')
    },
    {
      cacheTime: 0,
      enabled: true,
      onError: (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Không tìm thấy dữ liệu',
          text: ' ',
          confirmButtonText: 'Đóng lại',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            cancel(true)
          }
        })
      },
    }
  )

  if (device)
    return <ModalForm isLoading={isLoading} deviceInfo={device || { Id: "0" }} />
  return <Loading />
}

export { ModalFormWrapper }
